<template>
  <div class="pa-4 text-center">
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-medium fixed rounded bottom right dark color="primary" v-bind="attrs" v-on="on" @click="openDialog">
          Soporte de Pago
        </v-btn>
      </template>
      <span>Soporte de Pago</span>
    </v-tooltip>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img src="https://beneflex-icons.s3.amazonaws.com/clients/logo1.svg" class="custom-img" />
        </v-col>
        <h2 color="primary">Soporte de pago</h2>

        <v-container class="custom-archive">
          <v-row dense>
            <v-col class="col-sm-12 col-md-12">
              <p class="custom-text">
                Por favor adjuntar el soporte de consignación o transferencia realizado para el pago de tus
                reconocimientos.
              </p>
              <br>
              <div class="archive-container">
                <input type="file" class="btn-cargue" @change="handleFileChange" ref="fileInput" style="display: none;"
                  accept=".pdf" />
                <v-text-field readonly color="secondary" label="*Cargar Archivo" required
                  v-model="formData.fileDetailName" :rules="fileDetailRules" @click="triggerFileInput"
                  append-icon="mdi-paperclip"></v-text-field>
              </div>
            </v-col>
            <v-btn large block rounded :color="formData.fileDetail ? 'primary' : 'grey'" class="mb-4 custom-btn"
              style="color: white; border-radius: 50px;" :disabled="!formData.fileDetail" @click="confirmSubmit()">
              Enviar
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import {
  RECOGNITION_BUYING_M,
  ACTION_POST_PAYMENT_SUPPORT
} from "@/views/recognition/store/types/types.js";

import { mapActions } from 'vuex';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';

export default {
  name: "FormPaymentSupport",
  props: {
    methodotransactionProps: {
      required: true
    },
  },
  
  data() {
    return {
      dialog: false,
      formData: {
        fileDetailName: null,
        fileDetail: null,
        paymentMethodId: null,
        transactionId: null
      },
      fileDetailRules: [
        v => !!v || "Achivo en formato PDF es requerido"
      ],
    }

  },

  mounted() {
    this.initializeFormData();
  },
  methods: {
    initializeFormData() {
      if (this.methodotransactionProps) {
        this.formData.paymentMethodId = this.methodotransactionProps.paymentMethodId;
        this.formData.transactionId = this.methodotransactionProps.transactionId;
      }
    },
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      EventBus.$emit('close-dialog');
      this.dialog = false;
    },

    clearForm() {
      this.formData.fileDetailName = null;
    },

    handleFileChange(event) {
      const file = event.target.files[0];

      if (file.type === 'application/pdf') {

        const fileSizeMB = file.size / (1024 * 1024);
        const maxFileSizeMB = 30;

        if (fileSizeMB > maxFileSizeMB) {
          Swal.fire({
            icon: 'error',
            title: 'Error de validación',
            text: `El tamaño del archivo debe ser menor o igual a ${maxFileSizeMB} MB.`,
          });
          this.formData.fileDetailName = '';
          this.formData.fileDetail = null;
        } else {
          this.formData.fileDetailName = file.name;
          this.formData.fileDetail = file;
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error de validación',
          text: 'Por favor, selecciona un archivo en formato PDF.',
        });
        this.formData.fileDetailName = '';
        this.formData.fileDetail = null;
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    ...mapActions({
      postActionPaymentSupport: `${RECOGNITION_BUYING_M}${ACTION_POST_PAYMENT_SUPPORT}`,
    }),

    validateForm() {

      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.fileDetail) {
        errors.fileDetail = 'Cargar Archivo';
      }

      return errors;

    },

    confirmSubmit() {
      Swal.fire({
        title: '¿Desea efectuar el pago?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'No',
        confirmButtonColor: '#6E17A5'
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitForm();
        }
        else {
          Swal.fire({
            position: 'top-end',
            icon: 'info',
            title: 'La acción ha sido cancelada.',
            showConfirmButton: false,
            timer: 2500
          });
        }
      });
    },

    async submitForm() {
      try {
        const validationErrors = this.validateForm();
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join('<br>');
          Swal.fire({
            icon: 'error',
            title: 'Errores de validación',
            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });
          return;
        }
        const save = await this.postActionPaymentSupport(this.formData);
        if (!save) {
          return Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debes diligenciar los campos'
          })
        }
        await this.clearForm();
        EventBus.$emit('form-submit-products');
        this.dialog = false;
      } catch (error) {
        console.error("Fallo al enviar por", error)

      }
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 40vh;
}

.password-match-rule-error {
  color: red;
  font-size: 12px;
}

.small-x {
  font-size: smaller;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.custom-btn {
  border-radius: 50px;
  padding: 12px;
}

.custom-text {
  font-size: 16px;
  color: #000000;
  text-align: center;
  margin: 5px;
}

.archive-container {
  padding-bottom: 30px;
  text-align: center;
}


.custom-archive {
  color: #6E17A5;
  text-align: center;
  margin: 5px;
  padding-left: 60px;
  padding-right: 60px;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;

  }

  .custom-img {
    width: 100px;
  }
}
</style>